// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingSummaryResponse

import { hydrateWidgetBookingPriceSummary, type WidgetBookingPriceSummary, type WidgetBookingPriceSummaryApiResponse } from './widgetBookingPriceSummary.gen';
import { hydrateWidgetBookingBillingOptions, type WidgetBookingBillingOptions, type WidgetBookingBillingOptionsApiResponse } from './widgetBookingBillingOptions.gen';
import { hydrateWidgetBookingPaymentItem, type WidgetBookingPaymentItem, type WidgetBookingPaymentItemApiResponse } from './widgetBookingPaymentItem.gen';

export type WidgetBookingSummaryApiResponse = {
	summary: WidgetBookingPriceSummaryApiResponse | null;
	billingOptions: WidgetBookingBillingOptionsApiResponse;
	cancellationTimeBefore: number | null;
	payments: WidgetBookingPaymentItemApiResponse[];
};

export type WidgetBookingSummary = {
	summary: WidgetBookingPriceSummary | null;
	billingOptions: WidgetBookingBillingOptions;
	cancellationTimeBefore: number | null;
	payments: WidgetBookingPaymentItem[];
};

export function hydrateWidgetBookingSummary(data: WidgetBookingSummaryApiResponse): WidgetBookingSummary {
	return {
		...data,
		summary: data.summary ? hydrateWidgetBookingPriceSummary(data.summary) : null,
		billingOptions: hydrateWidgetBookingBillingOptions(data.billingOptions),
		payments: data.payments.map(hydrateWidgetBookingPaymentItem),
	};
}